import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const homeChildren = [
  {
    name: "news",
    path: "nowosci"
  },
  {
    name: "offer",
    path: "oferta"
  },
  {
    name: "company-management",
    path: "zarzad-firmy"
  },
  {
    name: "company-history",
    path: "historia-firmy"
  },
  {
    name: "contact",
    path: "kontakt"
  }
];

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/strona-glowna"
    },
    {
      name: "home",
      path: "/strona-glowna",
      children: homeChildren,
      component: () => import("../views/Home.vue")
    },
    {
      path: "/kontakt",
      redirect: "/strona-glowna"
    },
    {
      name: "offer-element",
      path: "/oferta/:title",
      component: () => import("../views/OfferElement.vue")
    },
    {
      name: "news-element",
      path: "/nowosci/:id",
      component: () => import("../views/NewsElement.vue")
    },
    {
      name: "privacy-policy",
      path: "/polityka-prywatnosci",
      component: () => import("../views/PrivacyPolicy")
    },
    {
      name: "not-found",
      path: "/nie-znaleziono",
      component: () => import("../views/NotFound.vue")
    }
  ]
});

export default router;
